import React from 'react';
import { AlertDialog as AlertDialogPrimitive, Dialog as DialogPrimitive } from 'radix-ui';

const withDisplayName = (Component, displayName) => {
  Component.displayName = displayName;
  return Component;
};

const DialogOverlay = withDisplayName(React.forwardRef((props, ref) => (
  <DialogPrimitive.Overlay ref={ref} {...props} />
)), 'DialogOverlay');

const DialogContent = withDisplayName(React.forwardRef((props, ref) => (
  <DialogPrimitive.Content ref={ref} {...props} />
)), 'DialogContent');

const DialogTitle = withDisplayName(React.forwardRef((props, ref) => (
  <DialogPrimitive.Title ref={ref} {...props} />
)), 'DialogTitle');

const DialogDescription = withDisplayName(React.forwardRef((props, ref) => (
  <DialogPrimitive.Description ref={ref} {...props} />
)), 'DialogDescription');

const AlertDialogOverlay = withDisplayName(React.forwardRef((props, ref) => (
  <AlertDialogPrimitive.Overlay ref={ref} {...props} />
)), 'AlertDialogOverlay');

const AlertDialogContent = withDisplayName(React.forwardRef((props, ref) => (
  <AlertDialogPrimitive.Content ref={ref} {...props} />
)), 'AlertDialogContent');

const AlertDialogTitle = withDisplayName(React.forwardRef((props, ref) => (
  <AlertDialogPrimitive.Title ref={ref} {...props} />
)), 'AlertDialogTitle');

const AlertDialogDescription = withDisplayName(React.forwardRef((props, ref) => (
  <AlertDialogPrimitive.Description ref={ref} {...props} />
)), 'AlertDialogDescription');

export {
  AlertDialogPrimitive as AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogTitle,
  DialogPrimitive as Dialog,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogTitle
};
